import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export const Hero = () => {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-brand-teal text-white min-h-[100svh] flex flex-col justify-center py-8 px-4 overflow-hidden" data-id="element-56">
      {/* Background subtle pattern/gradient */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-gold to-transparent" data-id="element-57"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-59">
          <span className="inline-block text-brand-gold font-bold tracking-wider text-xs md:text-base uppercase mb-3 md:mb-5 bg-brand-gold/10 px-4 py-1.5 rounded-full border border-brand-gold/20" data-id="element-60">
            KIT PSICOLOGÍA EN TCA™
          </span>

          <h1 className="font-serif text-2xl md:text-4xl lg:text-5xl font-bold leading-tight mb-3 md:mb-6 text-brand-cream" data-id="element-61">
            DEJÁ DE IMPROVISAR EN EL ABORDAJE DE TRASTORNOS DE LA CONDUCTA
            ALIMENTARIA
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="my-4 md:my-6 relative max-w-[18rem] md:max-w-[25rem] mx-auto" data-id="element-62">
          <img src="https://cdn.magicpatterns.com/uploads/41iNk4rdC7HqUpZkoQWoFn/Diseno_sin_titulo_(36).png" alt="KIT Psicología en TCA Mockup" className="w-full h-auto drop-shadow-2xl cursor-pointer hover:scale-[1.02] transition-transform duration-300" onClick={scrollToCompra} data-id="element-63" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-64">
          <p className="text-sm md:text-lg text-brand-cream/90 max-w-2xl mx-auto mb-5 md:mb-8 leading-relaxed" data-id="element-65">
            Sistema práctico para evaluar, conceptualizar e intervenir en
            trastornos de la conducta alimentaria con una estructura clínica e
            interdisciplinaria desde la primera consulta hasta el alta.
          </p>

          <div className="flex flex-col items-center gap-3" data-id="element-66">
            <Button className="text-base md:text-xl py-4 md:py-5 px-8 md:px-10 w-full md:w-auto animate-pulse-slow" data-id="element-67">
              SÍ, QUIERO EL KIT AHORA
            </Button>

            <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-brand-cream/80 mt-1" data-id="element-68">
              <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-69" />
              <span data-id="element-70">Acceso inmediato · Pago único y seguro</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};